import { useQuery } from '@tanstack/react-query';
import { getClinicPaymentConfig } from 'lib/api/firebase/apis/apis';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useGetClinicProductOptions(clinicId: string) {
  return useQuery({
    queryKey: queryKeyFactory.clinic.productOptions(clinicId),
    queryFn: () => getClinicPaymentConfig(clinicId).then(_ => _.data)
  });
}
